// context/data.js — county data and app context

import { createContext } from 'react';

export const MainContext = createContext(null);

export const CountyList = [
  {
    id:        1,
    title:     'Madison',
    region:    'South Central Iowa',
    highlight: 'Historic Covered Bridges',
    description: 'Home to the famous covered bridges immortalised in literature and film. Rolling hills, the North River, and charming Winterset make Madison County a must-visit.',
    faqs: [
      { question: 'What is Madison County known for?',    answer: 'The six historic covered bridges, featured in the novel and film "The Bridges of Madison County".' },
      { question: 'Where is Madison County located?',     answer: 'In south-central Iowa, about 30 miles southwest of Des Moines.' },
    ],
  },
  {
    id:        2,
    title:     'Delaware',
    region:    'Northeast Iowa',
    highlight: 'Maquoketa Caves State Park',
    description: 'Delaware County sits in the rolling hills of northeast Iowa. Maquoketa Caves State Park draws hikers and spelunkers from across the Midwest.',
    faqs: [
      { question: 'What is Delaware County known for?',   answer: 'Access to Maquoketa Caves State Park and the scenic Maquoketa River valley.' },
      { question: 'Where is Delaware County located?',    answer: 'In northeast Iowa, roughly between Dubuque and Waterloo.' },
    ],
  },
  {
    id:        3,
    title:     'Polk',
    region:    'Central Iowa',
    highlight: 'State Capitol & Gray\'s Lake',
    description: 'Iowa\'s most populous county and home to Des Moines, the state capital. World-class food scene, Gray\'s Lake, and the stunning gold-domed Capitol building.',
    faqs: [
      { question: 'What is Polk County known for?',  answer: 'It is home to Des Moines, Iowa\'s capital city, and the State Capitol building.' },
      { question: 'Where is Polk County?',           answer: 'In central Iowa — it is the geographic and population centre of the state.' },
    ],
  },
  {
    id:        4,
    title:     'Dubuque',
    region:    'Eastern Iowa',
    highlight: 'Mississippi Riverfront & Fenelon Place Elevator',
    description: 'One of Iowa\'s oldest cities, perched on bluffs above the Mississippi River. The Fenelon Place Elevator — the world\'s shortest, steepest scenic railway — is unmissable.',
    faqs: [
      { question: 'What is Dubuque County famous for?', answer: 'The Mississippi Riverfront, the Fenelon Place Elevator, and the National Mississippi River Museum.' },
      { question: 'Where is Dubuque County?',           answer: 'On Iowa\'s eastern border along the Mississippi River.' },
    ],
  },
  {
    id:        5,
    title:     'Johnson',
    region:    'Eastern Iowa',
    highlight: 'University of Iowa & Coralville Reservoir',
    description: 'Home to the University of Iowa and the vibrant college town of Iowa City — a UNESCO City of Literature. The Coralville Reservoir offers outstanding outdoor recreation.',
    faqs: [
      { question: 'What is Johnson County known for?', answer: 'The University of Iowa, Iowa City\'s literary heritage (a UNESCO City of Literature), and the Coralville Reservoir.' },
      { question: 'Where is Johnson County?',          answer: 'In eastern Iowa, about 25 miles south of Cedar Rapids.' },
    ],
  },
];